import axios from 'axios'
import miniToastr from 'mini-toastr'
// import moment from 'moment'
// import Vue from 'vue';
// import { EventBus } from '../../event-bus';

import configAll from '../../../../config/index.cjs'
import router from "../../../router/vocational.js";

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']

const API_URL = config.urlServerVocational
const TICKET_URL = `${API_URL}api/voc/tickets`
const TICKET_URL1 = `${API_URL}api/voc/ticket`
const TICKET_SECTION_URL = `${API_URL}api/voc/section`
const TICKET_SECTION_CONTENT_URL = `${API_URL}api/voc/sectioncontent`
const GET_TODO_URL = `${API_URL}api/voc/todo/`

export default {
  namespaced: true,
  state: {
    items: [],
    cats: [],
    selectedCatId: 0,
    totalItems: 0,
    item: [],
    categories: [],
    tags: [],
    itemTags: []
  },
  mutations: {
    setCats (state, items) {
      // eslint-disable-next-line
      state.cats = items;

      if (!state.selectedCatId) {
        state.selectedCatId = items[0]['id'];
      }

    },
    setCatId (state, catid) {
      // eslint-disable-next-line
      state.selectedCatId = catid;
    },
    setTickets(state, items) {
      // state.items = items;
      items.rows.forEach((item) => {
        const tags = []
        item.Tags.forEach((tag) => {
          tags.push(tag.title)
        })
        // eslint-disable-next-line
        item.tags = tags.join(', ');
      })

      // eslint-disable-next-line
      state.items = items.rows;
      // eslint-disable-next-line
      state.totalItems = items.count;
    },
    setTicket (state, item) {
      // eslint-disable-next-line
      state.item = item;
      let categories = [];
      item.TicketSections.forEach((data) => {
        if (data.TicketSectionCodes.length) {
          data.TicketSectionCodes.forEach((code) => {
            return Object.assign(code, { langdescr: `${code.lang}~~${code.description}`});
          })
        }
        categories.push(data);
      });

      const tags = []
      item.Tags.forEach((tag) => {
        tags.push({ text: tag.title })
      })
      // eslint-disable-next-line
      state.tags = tags;

      // sort categories
      // console.log(categories);
      // eslint-disable-next-line
      state.categories = categories
    },
    add(state, item) {
      state.items.push(item);
      //sort categories
    },
    addSection(state, item) {
      state.categories.push(item);
      //sort categories
    },
    addSectionContent(state, obj) {
      if (obj.type == 'todo') {
        if (state.item && state.item.TicketSections) {
          if (state.item.TicketSectionsTodos) {
            state.item.TicketSectionsTodos.push({
              id: obj.data.id,
              flag_done: 0,
              description: obj.data.description

            });
          } else {
            state.item.TicketSectionsTodos = [{
              id: obj.data.id,
              flag_done: 0,
              description: obj.data.description

            }];
          }
        }
      }
    },
    deleteTag (state, data) {
      const findTag = state.tags.find(item1 => item1.text === data.title)
      if (findTag) {
        const indexTag = state.tags.indexOf(findTag)
        if (indexTag > -1) {
          state.tags.splice(indexTag, 1)
        }
      }

      // const findTag1 = state.itemTags.find(item1 => item1.text === data.title)
      // if (findTag1) {
      //   const indexTag = state.itemTags.indexOf(findTag)
      //   if (indexTag > -1) {
      //     state.itemTags.splice(indexTag, 1)
      //   }
      // }
    },
    searchfilter (state, data) {
      let aa = data.rows;

      aa.forEach((item, key) => {
        // eslint-disable-next-line
        item.index = key;

        const tags = []
        item.Tags.forEach((tag) => {
          tags.push(`<span class="bg-breez-light" style="color: #fff; padding: 3px 3px;">#${tag.title}</span>`)
        })
        item.tags = tags.join(' ');

      })
      // console.log(aa)
      // eslint-disable-next-line
      state.items = aa;
      state.totalItems = data.count;
    }
  },
  actions: {
    getCats ({ commit }) {
      axios.get(`${API_URL}api/voc/ticketscat`)
        .then((response) => {
          commit('setCats', response.data)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Cats failed!', 1500);
        })
    },
    getTickets({ commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      let query = `offset=${offset}&limit=${limit}&cat_id=${opts.catid}`
      if (opts.status && opts.status.length) {
        query += `&status=${opts.status}`
      }
      axios.get(`${TICKET_URL}?${query}`)
        .then((response) => {
          // eslint-disable-next-line
          commit('setTickets', response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Tickets failed!', 1500);
        })
    },
    getTicket({ commit }, id) {
      axios.get(`${TICKET_URL}/${id}`)
        .then((response) => {
          // eslint-disable-next-line
          commit('setTicket', response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Ticket failed!', 1500);
        })
    },
    addSection ({ commit }, payload) {
      axios.post(`${TICKET_SECTION_URL}`, payload)
        .then((response) => {
          // eslint-disable-next-line
          commit('addSection', response.data);
          miniToastr.success('Added Section', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Section failed!', 1500);
        })
    },
    // eslint-disable-next-line
    editSection ({ commit }, obj) {
      delete obj.payload.TicketSectionCodes
      delete obj.payload.TicketSectionDescriptions
      delete obj.payload.TicketSectionTodos
      delete obj.payload.createdAt
      delete obj.payload.updatedAt
      delete obj.payload.flag_deleted
      axios.put(`${TICKET_SECTION_URL}`, obj.payload, { params: { id: obj.id } })
        // eslint-disable-next-line
        .then((response) => {
          // eslint-disable-next-line
          miniToastr.success('Edited Section', '', 1500)
          //commit('addSection', response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Update Section failed!', 1500);
        })
    },
    addSectionContent ({ commit }, payload) {
      axios.post(`${TICKET_SECTION_CONTENT_URL}`, payload)
        .then((response) => {
          // eslint-disable-next-line
          commit('addSectionContent', {data: response.data, type: payload.type});
          miniToastr.success('Added Section Content', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Section Content failed!', 1500);
        })
    },
    // eslint-disable-next-line
    editSectionContent ({ commit }, obj) {
      axios.put(`${TICKET_SECTION_CONTENT_URL}`, obj.payload, { params: { id: obj.id } })
        // eslint-disable-next-line
        .then((response) => {
          // eslint-disable-next-line
          miniToastr.success('Edited Section Content', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Update Section Content failed!', 1500);
        })
    },
    // eslint-disable-next-line
    setToDo({commit}, payload) {
      axios.put(GET_TODO_URL, payload, { params: { id: payload.id } })
        // eslint-disable-next-line
        .then((response) => {
          // commit('editItem', response.data)
          miniToastr.success('Updated To Do item', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Updated To Do item failed!', 1500)
        })
    },
    add ({ commit }, payload) {
      axios.post(`${TICKET_URL1}`, payload)
        .then((response) => {
          // eslint-disable-next-line
          commit('add', response.data);
          miniToastr.success('Added Ticket', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Ticket failed!', 1500);
        })
    },
    // eslint-disable-next-line
    edit ({ commit }, obj) {
      axios.put(`${TICKET_URL1}`, obj.payload, { params: { id: obj.id } })
        // eslint-disable-next-line
        .then((response) => {
          // eslint-disable-next-line
          miniToastr.success('Edited Ticket', '', 1500)
          //commit('addSection', response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Update Ticket failed!', 1500);
        })
    },
    // eslint-disable-next-line
    deleteTicket ({ commit }, ticketId) {
      axios.delete(`${TICKET_URL1}/${ticketId}`)
        .then(() => {
          miniToastr.success('Deleted Ticket', '', 1500)
          router.replace('/list')
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Ticket failed!', 1500)
        })
    },
    // eslint-disable-next-line
    deleteSection ({ commit }, sectionId) {
      axios.delete(`${TICKET_SECTION_URL}/${sectionId}`)
        .then(() => {
          miniToastr.success('Deleted Section', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Section failed!', 1500)
        })
    },
    // eslint-disable-next-line
    deleteSectionContent ({ commit }, obj) {
      axios.delete(`${TICKET_SECTION_CONTENT_URL}/${obj.type}/${obj.id}`)
        .then(() => {
          miniToastr.success('Deleted Section Content', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Section Content failed!', 1500)
        })
    },
    addTag ({ commit }, tag) {
      axios.post(`${API_URL}api/voc/tag/ticket/link`, tag)
        .then((response) => {
          commit('addTag', { ticket_id: tag.ticket_id, title: response.data.title })
          miniToastr.success('Added Tag!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Tag failed!', 1500)
        })
    },
    deleteTag ({ commit }, tag) {
      axios.post(`${API_URL}api/voc/tag/ticket/link/rm`, tag)
        .then((response) => {
          commit('deleteTag', response.data)
          miniToastr.success('Deleted Tag!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Tag failed!', 1500)
        })
    },
    search ( { commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      const searchKey = opts.searchType
      let query = `term=${encodeURI(opts.term)}&cat_id=${opts.catid}&search_key=${searchKey}&offset=${offset}&limit=${limit}`
      if (opts.status && opts.status.length) {
        query += `&status=${opts.status}`
      }
      axios.get(`${API_URL}api/voc/tickets/two/search?${query}`).then((response) => {
        commit('searchfilter', response.data)
      }).catch((err) => {
        miniToastr.error(err.response.data.errorMessage, 'Search failed!', 1500)
      })
    },
    // filter ( { commit }, opts) {
    //   // const offset = (opts.currentPage - 1) * opts.perpage
    //   // const limit = opts.perpage
    //   axios.get(`${API_URL}api/vocational/tickets/one/filter?status=${opts.status}`).then((response) => {
    //     commit('searchfilter', response.data)
    //   }).catch((err) => {
    //     miniToastr.error(err.response.data.errorMessage, 'Filter failed!', 1500)
    //   })
    // }

  },
  getters: {}
}
